import { Group } from '@/components/_common';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import StatusTag from '@/components/_common/StatusTag';
import {
  AccountPayableSituationColor,
  InstallmentSituationType,
} from '@/core/domain/financial/AccountPayable/AccountPayable.types';

import { useAccountPayableContext } from '@/pages/FinancialPages/BillToPayPage/ReleasesPage/ReleasesDetailsPage';
import { Row, Col, Space, Typography, Button } from 'antd';
import { ChevronLeft, ChevronRight } from 'react-feather';
import { FormattedMessage } from 'react-intl';
import AccountPayableDetailHeaderTag from './AccountPayableDetailHeaderTag';
import BankConciliationPopoverDetails from '@/components/_common/BankConciliation/BankConciliationPopoverDetails';

const AccountPayableDetailHeader: React.FC = () => {
  const {
    accountPayable,
    currentInstallment,
    totalInstallments,
    nextInstallment,
    prevInstallment,
  } = useAccountPayableContext();

  const isLastComplement = totalInstallments - 1 === currentInstallment;
  const isFirstComplement = currentInstallment === 0;

  const accountCode = String(accountPayable?.code).padStart(2, '0');
  const installmentIndex = String(currentInstallment + 1).padStart(2, '0');
  const installmentIndexTotal = String(totalInstallments).padStart(2, '0');

  const installment = accountPayable?.installmentPayables[currentInstallment];

  const statusColor = installment
    ? AccountPayableSituationColor[installment.situation]
    : 'default';

  const statusLabel = installment
    ? InstallmentSituationType[installment.situation]
    : null;

  const conciliateInstallmentResponse =
    installment?.conciliateInstallmentResponse;

  return (
    <Row
      gutter={[16, 8]}
      align="middle"
      justify="space-between"
      style={{ marginBottom: '24px' }}
    >
      <Col>
        <Typography.Title level={4} id="status">
          <Group gap={8}>
            <FormattedMessage id="commons.entity.situation" />:
            <StatusTag
              color={statusColor}
              label={statusLabel || installment?.situation || ''}
              size="lg"
            />
            {!!conciliateInstallmentResponse && (
              <BankConciliationPopoverDetails
                conciliatedInstallment={conciliateInstallmentResponse}
              />
            )}
            <AccountPayableDetailHeaderTag />
          </Group>
        </Typography.Title>
      </Col>

      <Col>
        <Space align="center">
          <Button
            icon={
              <AntdFeatherIcon
                icon={<ChevronLeft cursor="pointer" />}
                size={14}
              />
            }
            onClick={prevInstallment}
            disabled={isFirstComplement}
            size="small"
          />

          <Typography.Title level={5} style={{ margin: 0 }}>
            {`${
              accountCode || ''
            } - ${installmentIndex}/${installmentIndexTotal}`}
          </Typography.Title>

          <Button
            icon={
              <AntdFeatherIcon
                icon={<ChevronRight cursor="pointer" />}
                size={14}
              />
            }
            size="small"
            onClick={nextInstallment}
            disabled={isLastComplement}
          />
        </Space>
      </Col>
    </Row>
  );
};

export default AccountPayableDetailHeader;
